import React from 'react'

import { Container } from 'components/atoms/container'
import { StyledContainer } from 'components/atoms/container/index.styled'
import { ArticleCardWrapper } from 'components/molecules/articleCardWrapper'
import { ProgressScrollList } from 'components/molecules/progressScrollList'
import { StyledArticleContainer } from 'components/pages/homepage/index.styled'
import { domainLocales } from 'domainLocales'
import { IGeneralKnowledge } from 'interfaces/categories.interface'
import { Article } from 'interfaces/types'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { deviceLayout } from 'styles/breakpoint'
import { TRACK_GA } from 'utils/tracking'

const GeneralKnowledgeStyled = styled(StyledContainer)`
  .scroll-list-container .trust-list .scroll-track {
    display: flex;
    min-width: max-content;
    & > * {
      width: 80vw;
      margin: unset;
      ${deviceLayout.pcLayout`
          padding: 12px;
          width: 330px;
    `}
    }
  }
`

const GeneralKnowledge = ({
  articles,
  isMobile,
  isShowDot = false,
}: IGeneralKnowledge) => {
  const { locale } = useRouter()
  const { formatMessage: f } = useIntl()
  const sL = locale || 'vi-VN' // standardized locale
  const numberOfDots = isShowDot
    ? isMobile
      ? articles.length
      : Math.ceil(articles.length / 3)
    : 0
  return (
    <GeneralKnowledgeStyled className="general-knowledge">
      <header>{f({ id: 'categoryPage.explainer' })}</header>
      <StyledArticleContainer className="scroll-list-container articles-container">
        <ProgressScrollList numberOfDots={numberOfDots} className="trust-list">
          {articles?.slice(0, 3).map((article: Article, id: number) => (
            <Container key={article.id}>
              <ArticleCardWrapper
                article={article}
                headingType="h2"
                dataEventCategoryForCategory={TRACK_GA.ARTICLE_BANNER.category}
                dataEventCategoryForTitle={TRACK_GA.ARTICLE_BANNER.category}
                dataEventCategoryForBanner={TRACK_GA.ARTICLE_BANNER.category}
                dataEventActionForTitle={`Click ${id + 1}`}
                dataEventLabelForTitle={`https://${domainLocales[sL]}${article.permalink}`}
                dataEventActionForCategory={`Click ${id + 1}`}
                dataEventLabelForCategory={`https://${domainLocales[sL]}${article.category.permalink}`}
                dataEventActionForBanner={`Click ${id + 1}`}
                dataEventLabelForBanner={`https://${domainLocales[sL]}${article.permalink}`}
                type="author"
                size={isMobile ? 'lg' : 'sm'}
                banner={
                  <img
                    loading="lazy"
                    src={
                      (isMobile
                        ? article.featureImageMobile || article.featureImage
                        : article.featureImage) || '/images/bmrThumbnail.png'
                    }
                    alt={article.postTitle}
                  />
                }
                categoryLink={article.category.permalink}
                articleLink={article.permalink}
                direction="vertical"
                categoryName={article.category?.displayName}
                title={article.postTitle}
                text={''}
                styleLabel={{
                  color: article.category.textColor,
                }}
                uploadTime={article.modifiedTime}
              />
            </Container>
          ))}
        </ProgressScrollList>
      </StyledArticleContainer>
    </GeneralKnowledgeStyled>
  )
}

export default GeneralKnowledge
